import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { Tab, Tabs } from '@occc/ui-design-system';
import { getTabItems, TabItem } from './utils';
import { CampaignComponentTabs } from './constants';

type ConfigurationLayoutProps = {
  children?: ReactNode;
  selectedTab: string;
  onTabSelected: (value: CampaignComponentTabs) => void;
  disabled: boolean;
  onGetTabLabel?: (item: TabItem) => string;
  isDesignTabHidden?: boolean;
};

export const ConfigurationLayout = ({
  children,
  selectedTab,
  onTabSelected,
  disabled,
  onGetTabLabel,
  isDesignTabHidden = false,
}: ConfigurationLayoutProps) => {
  const items = getTabItems(disabled, isDesignTabHidden);

  return (
    <>
      <Box ml={2}>
        <Tabs
          indicatorColor='secondary'
          textColor='secondary'
          value={selectedTab}
          onChange={(e, value) => onTabSelected(value)}
        >
          {items.map((item) => (
            <Tab
              key={item.value}
              value={item.value}
              label={onGetTabLabel?.(item) ?? item.label}
              disabled={item.disabled}
            />
          ))}
        </Tabs>
      </Box>

      {children}
    </>
  );
};
